import type { Municipio } from '@/api/modelos'

/**
 * A donde va el usuario despues de entrar: si tiene un solo municipio, derecho
 * a su panel; si tiene varios (o ninguno), a elegir.
 */
export function destinoTrasEntrar(municipios: Municipio[]): string {
  const unico = municipios.length === 1 ? municipios[0] : undefined

  return unico === undefined ? '/municipios' : `/m/${unico.slug}`
}
